<template>
	<FormGroup
			:name="name"
			:label="label"
			:corner-hint="cornerHint"
			:help-text="helpText"
			:error-text="errorText">

		<!-- Input Details -->
		<div class="relative mt-2 rounded-md shadow-none">

			<!-- If there is a leading icon before the input -->
			<div v-if="leadingIcon" class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
				<component :is="leadingIcon" :class="[
            { 'text-gray-400': !isError },
            { 'text-red-600': isError },
            'h-5 w-5'
        ]" aria-hidden="true"/>
			</div>

			<!-- The input -->
			<label class="block">
			<span class="sr-only">Choose file</span>
			<input
					:key="fileInputKey"
					@change="$emit('update:modelValue', $event.target.files[0])"
					type="file"
          :accept="accept"
					class="block w-full text-sm text-slate-500
			      file:mr-4 file:py-2.5 file:px-3.5
			      file:rounded-md
			      file:border file:border-solid file:border-gray-300
			      file:text-sm file:font-semibold
			      file:bg-white file:text-gray-900
			      hover:file:bg-surface-50
		        file:shadow-sm file:transition-colors
			    "/>
		</label>

		</div>

	</FormGroup>
</template>

<script>
import { IconAlertSquareRoundedFilled, IconSearch } from "@tabler/icons-vue";
import FormGroup from "@/Components/FormGroup.vue";

export default {
	name: "FileInput",
	components: {
		FormGroup,
		IconSearch,
		IconAlertSquareRoundedFilled
	},
	props: {
		name: String,
		label: String,
		cornerHint: String,
		helpText: String,
		errorText: String,
		disabled: Boolean,
		placeholder: String,
		accept: {
			type: String,
			default: '*/*',
		},
		leadingIcon: String,
		modelValue: {},
	},
	data() {
		return {
			fileInputKey: 0
		}
	},
	emits: ['update:modelValue'],
	computed: {
		isError() {
			return !!this.errorText?.length;
		}
	},
	methods: {
		focus() {
			this.$refs.input.$el.focus();
		},
		clear() {
			this.fileInputKey++;
		}
	},
	watch: {
		modelValue(newValue, oldValue){
			if(!newValue)
				this.clear()
		}
	}
}
</script>

<style scoped>

</style>